import { addDaysToIsoDate } from '@/utils/isoDateMath'

/** Side-by-side River Oaks / Highland Park panes from `md` up; stacks on small screens. */
export const LABOR_STORE_PANE_GRID_CLASS = 'grid grid-cols-1 gap-4 md:grid-cols-2'

/** Monday=0 … Sunday=6, matching Python date.weekday(). */
function weekdayMonday0(iso: string): number {
  const [yearStr, monthStr, dayStr] = iso.split('-')
  const date = new Date(Number(yearStr), Number(monthStr) - 1, Number(dayStr))
  return (date.getDay() + 6) % 7
}

export function saturdayWeekEnded(iso: string): string {
  const daysUntilSaturday = (5 - weekdayMonday0(iso) + 7) % 7
  return addDaysToIsoDate(iso, daysUntilSaturday)
}

export function weekDateRange(weekEnded: string): { start: string; end: string } {
  return { start: addDaysToIsoDate(weekEnded, -6), end: weekEnded }
}

/** Saturdays for calendar weeks overlapping [start, end], newest first. */
export function weeksEndingInRange(start: string, end: string): string[] {
  if (!start || !end || start > end) return []
  const weeks: string[] = []
  let current = saturdayWeekEnded(start)
  while (current <= end) {
    weeks.push(current)
    current = addDaysToIsoDate(current, 7)
  }
  return weeks.reverse()
}

export function isPartialWeek(weekEnded: string, rangeStart: string, rangeEnd: string): boolean {
  const { start, end } = weekDateRange(weekEnded)
  return start < rangeStart || end > rangeEnd
}

export function formatWeekEndedLabel(
  weekEnded: string,
  rangeStart: string,
  rangeEnd: string,
): string {
  const [yearStr, monthStr, dayStr] = weekEnded.split('-')
  const pretty = new Date(Number(yearStr), Number(monthStr) - 1, Number(dayStr)).toLocaleDateString(
    undefined,
    { month: 'short', day: 'numeric', year: 'numeric' },
  )
  const suffix = isPartialWeek(weekEnded, rangeStart, rangeEnd) ? ' (partial)' : ''
  return `Ended ${pretty}${suffix}`
}

/** Light-to-strong red fill; `max` is the store-wide peak OT hours in the pulled range. */
export function otHeatBackground(value: number, max: number): string | undefined {
  if (!(value > 0) || !(max > 0)) return undefined
  const t = Math.min(1, value / max)
  const alpha = 0.08 + t * 0.4
  return `rgba(220, 38, 38, ${alpha.toFixed(3)})`
}

export function maxPositive(values: number[]): number {
  return values.reduce((peak, value) => (value > peak ? value : peak), 0)
}
